export default __webpack_public_path__ + "cde300f83564403ac73938f9ac662d4e.png";